const Colors = {
	white: 'white',
	blue: '#034781',
	lightblue: '#0270CB',
	grey: '#333333',
	lightgrey: '#D5E3F0',
};

export {
	Colors,
};